<app-user-header class="d-md-none"></app-user-header> 
<div class="row m-0 h-100 row-container" > 


  <div class="col-md-2 pe-0 ps-0 section-side-nav h-100 d-none d-md-block">
    <app-admin-sidebar></app-admin-sidebar>
  </div>
  <div class="col-md-10 big-area p-0">

<div class="wrapperi" *ngIf="opening && opening.businessID">
    <div class="col-12 row mt-4">
        <div class="col-1"></div>
        <div class="col-10">
            <h2>Ilmoitukset</h2>
            <p>Tässä näet ilmoitukset</p>
            <div class="col-12 row p-0 m-0">
                <div class="col-4 p-0">
                    <div class=" formed-shadow bg1">
                        
                        <div class="p-4 row">
                            <div class="col text-start">
                                <h2 class="white-text ">{{opening.views_number}}</h2>
                                <p class="white-text">Katselua</p>
                            </div>
                            <div class="col-3 text-end d-flex justify-content-end">
                                <div class="whiteball mt-3 d-flex align-items-center justify-content-center text-center">
                                    <i class="far icon-1 big-icon fa-user"></i>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="col-4">
                    <div class=" formed-shadow bg2">
                        <div class="p-4 row">
                            <div class="col text-start">
                                <h2 class="white-text ">{{opening.applicants.length}}</h2>
                                <p class="white-text">Hakemusta</p>
                            </div>
                            <div class="col-3 text-end d-flex justify-content-end">
                                <div class="whiteball mt-3 d-flex align-items-center justify-content-center text-center">
                                    <i class="far icon-2 big-icon fa-search-plus"></i>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="col-4 p-0">
                    <div class=" formed-shadow bg3">
                        <div class="p-4 row">
                            <div class="col text-start">
                                <h2 class="white-text ">{{opening.starred_by.length}}</h2>
                                <p class="white-text">Tallennuksia</p>
                            </div>
                            <div class="col-3 text-end d-flex justify-content-end">
                                <div class="whiteball mt-3 d-flex align-items-center justify-content-center text-center">
                                    <i class="far icon-3 big-icon fa-lock-open"></i>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
<!--             <button class="btn btn-formed-main-black mt-4" data-bs-toggle="modal" data-bs-target="#categories">Kategorisointi</button>
 -->        </div>
        <div class="col-1"></div>
    </div>


  
  
    <div class="col-12 p-0 row m-0">
      <div class="col-1"></div>
      <div class="col-12 mt-4 col-md-10 p-0 input-cover ">
        <h2>Työpaikan tiedot</h2>
            <div class="col-12 row">
                <div class="col-4">
                    <ng-container *ngIf="!opening.logo; else logo_content">
                        <img src="../../assets/images/formed_favicon.png" width="100"/>
                    </ng-container>
                    <ng-template #logo_content>
                        <img src="{{opening.logo}}" width="100"/>
                    </ng-template>
                    <p class="mt-4">{{opening.description_fi | truncate : 200 : true}}</p>
                </div>
                <div class="col-8">
                    <div class="card formed-shadow">

                            <div class="table-responsive" *ngIf="opening">
                                <table class="table align-items-center table-flush">
                                    <tbody class="tbody-light">
                                        <tr>
                                            <td class="bold">Ammattilainen</td>
                                            <td>{{opening.mdType.name_fi }}</td>
                                        </tr>
                                        <tr *ngIf="opening.mdSubType">
                                            <td class="bold">Ammattilainen</td>
                                            <td>{{opening.mdSubType.name_fi}}</td>
                                        </tr>
                                        <tr>
                                            <td class="bold">Sijainti</td>
                                            <td>{{opening.location.city}}</td>
                                        </tr>
                                        <div class="d-flex mt-2" *ngIf="opening.wage_monthly">
                                            <p class="semiboldtextblue80016 mb-0">Palkka:</p>
                                            <p class="normaltextblue80016 mb-0 ms-2">{{opening.wage_monthly}}€/kk</p>
                                        </div>
                                        <div class="d-flex mt-2" *ngIf="opening.wage_hourly">
                                            <p class="semiboldtextblue80016 mb-0">Palkka:</p>
                                            <p class="normaltextblue80016 mb-0 ms-2">{{opening.wage_hourly}}€/h</p>
                                        </div>
                                        <tr>
                                            <td class="bold">Työsuhteen tyyppi</td>
                                            <td>
                                                {{opening.work_type | workpossibility}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="bold">Työaika</td>
                                            <td>
                                                <span *ngIf="opening.timing == 'part_time'">Osa-aikatyö</span>
                                                <span *ngIf="opening.timing == 'full_time'">Kokoaikatyö</span>
                                                <span *ngIf="opening.timing == '3_shift_work'">3-vuorotyö</span>
                                                <span *ngIf="opening.timing == '2_shift_work'">2-vuorotyö</span>
                                                <span *ngIf="opening.timing == 'negotiable'">Sovittavissa</span>
                                                <span *ngIf="opening.timing == 'hourly'">Tuntityö</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="bold">Haku päättyy</td>
                                            <td>{{opening.application_ends | formateDate}}</td>
                                        </tr>
                                    </tbody>
                 
                  
                                </table>

                            </div>
                        </div>
                </div>

                </div>
                <div class="col-12" *ngIf="opening && opening.applicants.length > 0">
                    <h2>Hakijat</h2>
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th>
                                    PVM
                                </th>
                                <th>
                                    ID
                                </th>
                                <th>
                                    Työnantajia nähnyt
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="" *ngFor="let data of opening.applicants">
                                <td>
                                    {{data.createdDate}}
                                </td>
                                <td>
                                    {{data.userID}}
                                </td>
                                <td *ngIf="data['viewed_by']">
                                    {{data['viewed_by'].length}}
                                </td>

                            </tr>
                        </tbody>

                    </table>

                </div>
                <div class="col-12" *ngIf="opening.starred_by.length > 0">
                    <h2>Tallennettu</h2>
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th>
                                    PVM
                                </th>
                                <th>
                                    ID
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="" *ngFor="let data of opening.starred_by">
                                <td>
                                    {{data.createdDate}}
                                </td>
                                <td>
                                    {{data.userID}}
                                </td>

                            </tr>
                        </tbody>

                    </table>

                </div>

            </div>
        </div>

        <div class="col-1"></div>
  </div>

  </div>

    </div>

            <!-- Modal Check before deleting offer -->
            <button data-bs-toggle="modal" data-bs-target="#categories" style="display:none"></button>
            <div class="modal fade" id="categories" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Kategoriat</h5>
                    <!-- <p>Kaikki tähdellä merkityt kentät ovat pakollisia</p> -->
                    <button type="button" class="close" id="close-sub-md-modal" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <h5 class="text-center">Kategoriat</h5>
                    <p>Valitse listasta mihin kategoriaan haluat tämän lisätä</p>

                    <div class="">
                        <h2>Valitse kategoriat</h2>
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th>
                                        Nimi
                                    </th>
                                    <th>
                                        Valinta
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="" *ngFor="let data of categories">
                                    <td>
                                        {{data.name_fi}}
                                    </td>
                                    <td>
                                        {{data.ends | formateDate}}
                                    </td>

    
                                </tr>
                            </tbody>
    
                        </table>


                    
                </div>
                </div>
            </div>
            </div>